import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { Segment, VerticalSpacer } from './../core/core';
import PrimaryButton from './../components/PrimaryButton/PrimaryButton';
import moodboardScreenshot from '../images/example-moodboard.png';
import styles from './../SCSS/ClassroomDashboard.module.scss';
import utilityStyles from './../SCSS/common/utilityStyles.module.scss';
import segmentStyles from './../SCSS/Segment.module.scss';

const MarketingMoodBoard = () => {
  const history = useHistory();
  return (
    <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
      <VerticalSpacer ems={2} />
      <Segment className={utilityStyles.line}>
        <div className={segmentStyles.moduleTitle}>Student Moodboard Report Example</div>
      </Segment>
      <Segment className={utilityStyles.line}>
        <div className={styles.marketingCopy}>
          <p>
            With Peekapak’s new game, myPeekaville, students can ‘check-in’ daily by selecting how they’re feeling,
            providing teachers with a heatmap of student sentiment.
          </p>

          <p>
            myPeekaville uses story-based learning, exciting games, an immersive world, engaging narration, and
            beautiful visuals to bring learning to life. To access myPeekaville, please upgrade to the Peekapak PRO
            subscription:
          </p>
          <div className='ctaButton'>
            <PrimaryButton onClick={() => history.push('/features')}>Upgrade Now</PrimaryButton>
          </div>
        </div>
        <img
          alt='Screenshot'
          className={cx(utilityStyles.marketingScreenshot, styles.marketingImg)}
          src={moodboardScreenshot}
        />
      </Segment>
    </div>
  );
};

export default MarketingMoodBoard;
